import { LegalClientBranchEntity } from 'api/types/entity/legal/branch';

import { NameFormType } from '../../forms/nameForm';

export const getInitialData = (
  entity?: LegalClientBranchEntity
): NameFormType | undefined =>
  entity?.fullName ? { fullName: entity.fullName } : undefined;
